import { Permission } from '../enums';
import { Avatar, Group, Organisation, SelectOption } from '../models';

export interface IUser {
  id: string;
  createdAt: string;
  registeredAt: string | null;
  updatedAt: string | null;
  name: string;
  email: string;
  avatar: Avatar;
  groups: UserGroup[];
  organisations: Organisation[];
  deletedAt?: string | null;
  new?: boolean;
  invite?: string;
}

export interface IUserWithPartner {
  id: string;
  createdAt: string;
  registeredAt: string | null;
  updatedAt: string | null;
  name: string;
  email: string;
  avatar: Avatar;
}

export interface IUserWithPermissions {
  id: string;
  createdAt: string;
  registeredAt: string | null;
  updatedAt: string | null;
  name: string;
  email: string;
  avatar: Avatar;
  groups: UserGroup[];
  permissions: Permission[];
}

export interface ListUsersPayload {
  includeOnlyInternalUsers: boolean;
}

export type UserGroup = Omit<Group, 'users'>;
export type UserDetailsPermissionsList = Omit<SelectOption<string>, 'value'>;
